<div class="py-1" role="none">
    <ng-container>
        <a href="javascript:void(0)" *ngIf="transaction.type ==='charge'" (click)="refund.emit(transaction)"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="mr-3 h-5 w-5 text-main-primary ">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M8.25 9.75h4.875a2.625 2.625 0 0 1 0 5.25H12M8.25 9.75 10.5 7.5M8.25 9.75 10.5 12m9-7.243V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185Z" />
            </svg>
            Refund
        </a>

    </ng-container>

</div>